<template>

  <div class="page flex-col">
    <div class="group_1 flex-col" style="position: relative;">
      <div class="box_1 flex-row justify-between">
        <img class="label_1" v-if="userBaseInfoVo.companyLogo" referrerpolicy="no-referrer" style="border-radius: 4px;" :src="userBaseInfoVo.companyLogo" />
        <span class="text_1 text_over">{{ userBaseInfoVo.companyName|| '' }}</span>
      </div>
      <div class="box_2 flex-row">
        <span class="text_2">{{ userBaseInfoVo.name|| '微信用户' }}</span>
        <div class="image-wrapper_1 flex-col justify-center align-center">
          <!-- <img v-if="userBaseInfoVo.isRealName" class="label_2" referrerpolicy="no-referrer" src="https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/0ed1b38fea8d45a8a687f7f3cc2e931c_mergeImage.png" />
          <img v-else class="label_2" referrerpolicy="no-referrer" src=" https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/noreal.png" /> -->
        </div>
      </div>
      <div class="box_222 flex-row">
        <span class="text_3 text-ellipsis-2">{{ userBaseInfoVo.position|| '' }}</span>
      </div>
      <div class="box_3" style="margin-top: auto;">
        <div style="display: flex;align-items:center ; " v-if="phoneFilter">
          <img class="label_3" referrerpolicy="no-referrer" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/phone-icon.png" />
          <span class="text_5">{{ userBaseInfoVo.phoneCountryCode ? userBaseInfoVo.phoneCountryCode + ' ' : '' }}{{ phoneFilter }}</span>

        </div>
        <div style="display: flex;align-items:center ;" v-if="userBaseInfoVo.email">
          <img class="label_3" style="height: 26px;" referrerpolicy="no-referrer" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/email-icon.png" />
          <span class="text_5">{{ userBaseInfoVo.email|| '' }}</span>

        </div>
        <div style="display: flex;align-items:center ;" v-if="userBaseInfoVo.fullAddress">
          <img class="label_3" referrerpolicy="no-referrer" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/address.png" />
          <span class="text_5 text_over">{{ userBaseInfoVo.fullAddress|| '' }}</span>

        </div>
      </div>
      <div class="image-wrapper_3 flex-col">
        <img class="" referrerpolicy="no-referrer" :src="userBaseInfoVo.qrCodeUrl" />
      </div>
      <img class="image_2" referrerpolicy="no-referrer" :src="logo"  v-if="logo"/>
      <div class="corner" style="bottom: 0; right: 0;color:#00C4C9; position: absolute;" v-if="language != 'CN' && language">
        {{ getLanguageText }}
      </div>

    </div>
    <div id='DONE' v-if="complete"></div>
  </div>
</template>

<script>
import { GetQueryString, loadImageEnd } from '@/utils/utils'
import { getMyUserInfo, getOtherUserInfo } from '../../api/posterApi'
import { queryUserHomePage } from '@/api/customPageApi'
export default {
  name: 'businesscard',

  data() {
    return {
      token: '',
      appKey: '',
      eventKey: '',
      id: '',
      shareCode: '',
      isContact: 'N',
      complete: false,
      userBaseInfoVo: {},
      logo: '',
      showVcard:''
    }
  },

  created() {
    this.token = decodeURIComponent(GetQueryString('token'))
    this.appKey = decodeURIComponent(GetQueryString('appKey'))
    this.eventKey = decodeURIComponent(GetQueryString('eventKey'))
    this.showVcard = decodeURIComponent(GetQueryString('showVcard')) || ''
    this.language = decodeURIComponent(GetQueryString('language'))
    this.shareCode = decodeURIComponent(GetQueryString('shareCode')) || ''

    if (this.eventKey == 'MEHZ') {
      this.logo = `https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/card-mehz-logo.png`
    } else if (this.eventKey == 'WeMeet') {
      this.logo = `https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/image/WeMeetMiniLogo.png`
    } else if (this.eventKey == 'MEETSG') {
      this.logo = `https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MeetSG-Static/index-logo.png`
    }else{
      this.logo = ''
    }
    this.isContact = decodeURIComponent(GetQueryString('isContact'))
    this.uid = decodeURIComponent(GetQueryString('uid'))
    this.init()
  },

  computed: {
    bgColor() {
      return this.eventKey == 'MEHZ' ? 'bg-mehz' : 'bg-sg-WeMeet'
    },
    getLanguageText() {
      let language = this.language
      switch (language) {
        case 'EN':
          return '英文'
        case 'FR':
          return '法语'
        case 'RU':
          return '俄语'
        case 'ES':
          return '西班牙语'
        case 'JA':
          return '日语'
        case 'KO':
          return '韩语'
        case 'ID':
          return '印度尼西亚语'
        case 'VI':
          return '越南语'
        case 'DE':
          return '德语'
        case 'TR':
          return '土耳其语'
        case 'PT':
          return '葡萄牙语'
        case 'IT':
          return '意大利语'
        case 'TH':
          return '泰语'
        case 'MS':
          return '马来语'
        case 'AR':
          return '阿拉伯语'
      }
    },
    phoneFilter() {
      if (!this.userBaseInfoVo?.phone) {
        return false
      }
      if (this.userBaseInfoVo.phone.length != 11) {
        return this.userBaseInfoVo.phone
      }
      let start = this.userBaseInfoVo.phone.slice(0, 3)
      let main = this.userBaseInfoVo.phone.slice(3, 7)
      let end = this.userBaseInfoVo.phone.slice(7)
      return start + '-' + main + '-' + end
    },
  },

  methods: {
    init() {
      var headerClientInfo = { language: 'CN', eventKey: this.eventKey, appKey: this.appKey }
      let headers = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
        Authorization: this.token,
      }
      queryUserHomePage(headers, this.uid, this.language, this.shareCode).then((res) => {
        this.userBaseInfoVo = res.data.userBaseInfoVo
        if((this.language != 'CN' && this.userBaseInfoVo.vCardUrl) || (this.showVcard&& this.userBaseInfoVo.vCardUrl)){
          this.userBaseInfoVo.qrCodeUrl = this.userBaseInfoVo.vCardUrl
        }
        let allImg = [this.userBaseInfoVo.qrCodeUrl]
        loadImageEnd(allImg, () => {
          console.log('图片加载完毕')
          this.complete = true
        })
      })
      // if (this.isContact == 'N') {
      //   getMyUserInfo(headers).then((res) => {
      //     console.log(res)
      //     this.userBaseInfoVo = res.data.userBaseInfoVo
      //     let allImg = [this.userBaseInfoVo.qrCodeUrl]
      //     loadImageEnd(allImg, () => {
      //       console.log('图片加载完毕')
      //       this.complete = true
      //     })
      //   })
      // } else {
      //   getOtherUserInfo(headers, this.uid).then((res) => {
      //     console.log(res)
      //     this.userBaseInfoVo = res.data.userBaseInfoVo
      //     let allImg = [this.userBaseInfoVo.qrCodeUrl]
      //     loadImageEnd(allImg, () => {
      //       console.log('图片加载完毕')
      //       this.complete = true
      //     })
      //   })
      // }
    },
  },
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: 'MyFont';
  src: url('https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/file/SourceHanSansSC-VF.woff2') format('woff2');
  // src: url('https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/file/test.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}
div {
  font-family: 'MyFont', sans-serif !important;
}
.group_1 {
  box-shadow: 0px 8px 60px 0px rgba(0, 0, 0, 0.12);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 20px;
  position: relative;
  width: 702px;
  height: 400px;
  padding-top: 30px;
}

.box_1 {
  width: 386px;
  height: 44px;
  margin: 0 0 10px 30px;
}

.label_1 {
  width: 44px;
  height: 44px;
}

.text_1 {
  width: 332px;
  height: 34px;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 24px;
  font-family: 'MyFont';
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 34px;
  margin-top: 5px;
}

.box_2 {
  width: 278px;
  height: 50px;
  margin: 0px 0 0 30px;
}
.box_222 {
  width: 278px;
  height: 50px;
  margin: 0px 0 0 10px;
}

.text_2 {
  max-width: 308px;
  height: 50px;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 36px;
  font-family: 'MyFont';
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 50px;
  text-overflow: ellipsis;

  /* 设置超出容器的文字隐藏 */
  overflow: hidden;

  /* 设置如何处理空白和换行符 */
  white-space: nowrap;
}

.image-wrapper_1 {
  background-color: rgba(216, 216, 216, 0);
  height: 36px;
  width: 36px;
  margin: 7px 0 0 5px;
}

.label_2 {
  width: 36px;
  height: 36px;
}

.text_3 {
  width: 308px;
  height: 36px;
  overflow-wrap: break-word;
  color: rgba(140, 140, 140, 1);
  font-size: 26px;
  font-family: 'MyFont';
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 36px;
  margin: 7px 0 0 20px;
}

.text_4 {
  width: 144px;
  height: 30px;
  overflow-wrap: break-word;
  color: rgba(140, 140, 140, 1);
  font-size: 24px;
  font-family: 'MyFont';
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 34px;
  margin: 10px 0 0 30px;
}

.box_3 {
  position: relative;
  width: 380px;
  margin: 85px 0 29px 30px;
}

.image-text_1 {
  width: 261px;
}

.label_3 {
  width: 32px;
  height: 32px;
  margin-top: 1px;
}

.text-group_1 {
  width: 218px;
}

.text_5 {
  width: 330px;
  height: 34px;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 24px;
  font-family: 'MyFont';
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 34px;
  margin-left: 5px;
}
.text_over {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text_6 {
  width: 3200px;
  height: 340px;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 240px;
  font-family: 'MyFont';
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 340px;
  margin-top: 100px;
}

.text_7 {
  width: 3200px;
  height: 340px;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 240px;
  font-family: 'MyFont';
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 340px;
  margin-top: 100px;
}

.image-wrapper_2 {
  background-color: rgba(216, 216, 216, 0);
  height: 320px;
  width: 320px;
  position: absolute;
  left: 0;
  top: 450px;
}

.label_4 {
  width: 300px;
  height: 230px;
  margin: 50px 0 0 20px;
}

.image-wrapper_3 {
  height: 271px;
  background-size: 100% 100%;
  width: 270px;
  position: absolute;
  left: 402px;
  top: 49px;
}

.image_1 {
  width: 121px;
  height: 122px;
  margin: 75px 0 0 75px;
}

.image_2 {
  position: absolute;
  left: 472px;
  top: 319px;
  width: 130px;
  height: 32px;
}
.corner {
  border-bottom-right-radius: 20px;
  border-top-left-radius: 20px;
  background: #d1feff;
  font-size: 20px;
  padding: 0 28px;
}
</style>